class Service {

    constructor(model_root) {
        this.model_root = model_root;
    }

    loadFiles(content, type) {
        return fetch(this.model_root + 'shared/files/load_files.php?c=' + content + '&t=' + type, {
            method: "GET"
        })
            .then(response => response.json());
    }

    removeFile(fid) {
        return fetch(this.model_root + 'admin/files/delete_file.php?fid=' + fid, {
            method: "GET"
        })
    }

}

export default Service;
